module.exports = __webpack_public_path__ + "media/images/animations/overhight_load/5-deb7e3937f607880d68572013827d1b6.png";